export default __webpack_public_path__ + "static/media/img-full-circle-economy-new.c3767e60.png";